import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RatingStarsComponent } from './components/rating-stars/rating-stars.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    RatingStarsComponent
  ],
  exports: [
    RatingStarsComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ]
})
export class RatingStarsModule { }
